<template>
  <div>
    <head>
      <meta charset="utf-8" />
      <title>Customer Management - County Revenue System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Customer management system by County" name="description" />
      <link rel="shortcut icon" href="assets/images/favicon.png">

      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
    <NavigationBar/>
    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- Alert Messages -->
          <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
            {{message}}
            <button type="button" class="btn-close" @click="clearAlert()"></button>
          </div>

          <div v-if="alert.info" class="alert alert-primary alert-dismissible fade show" role="alert">
            {{message}}
            <button type="button" class="btn-close" @click="clearAlert()"></button>
          </div>

          <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{message}}
            <button type="button" class="btn-close" @click="clearAlert()"></button>
          </div>

          <!-- Page Title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Customer Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item active">Customers</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Statistics Cards -->
          <div class="row">
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Customers</p>
                      <h4 class="mb-0">{{formatNumber(statistics.totalCustomers)}}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-primary align-self-center">
                                            <span class="avatar-title">
                                                <i class="bx bx-user font-size-24"></i>
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Customers</p>
                      <h4 class="mb-0">{{formatNumber(statistics.activeCustomers)}}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-success align-self-center">
                                            <span class="avatar-title">
                                                <i class="bx bx-check-circle font-size-24"></i>
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Revenue</p>
                      <h4 class="mb-0">{{formatPrice(statistics.totalRevenueCollected)}}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-warning align-self-center">
                                            <span class="avatar-title">
                                                <i class="bx bx-money font-size-24"></i>
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Outstanding Balance</p>
                      <h4 class="mb-0">{{formatPrice(statistics.totalOutstandingBalance)}}</h4>
                    </div>
                    <div class="mini-stat-icon avatar-sm rounded-circle bg-danger align-self-center">
                                            <span class="avatar-title">
                                                <i class="bx bx-error-circle font-size-24"></i>
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Customer List -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6">
                      <h4 class="card-title">Customer List</h4>
                    </div>
                    <div class="col-md-6 text-end">
                      <div class="d-flex justify-content-end gap-2">
                        <select v-model="filter" @change="getAllCustomers()" class="form-select form-select-sm w-auto">
                          <option value="all">All Customers</option>
                          <option value="withBalance">With Balance</option>
                          <option value="active">Active</option>
                        </select>

                        <select v-model="sortBy" @change="getAllCustomers()" class="form-select form-select-sm w-auto">
                          <option value="recent">Most Recent</option>
                          <option value="name">By Name</option>
                          <option value="totalBilled">Total Billed</option>
                          <option value="balance">Balance</option>
                        </select>

                        <button @click="exportCustomers()" class="btn btn-sm btn-success">
                          <i class="bx bx-download"></i> Export
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Search Bar -->
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <div class="search-box">
                        <div class="position-relative">
                          <input v-model="searchTerm"
                                 @keyup.enter="searchCustomers()"
                                 type="text"
                                 class="form-control"
                                 placeholder="Search by phone, name or ID...">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <select v-model="searchType" class="form-select">
                        <option value="all">All Fields</option>
                        <option value="phone">Phone Number</option>
                        <option value="name">Name</option>
                        <option value="id">ID Number</option>
                      </select>
                    </div>
                    <div class="col-md-2">
                      <button @click="searchCustomers()" class="btn btn-primary w-100">
                        <i class="bx bx-search"></i> Search
                      </button>
                    </div>
                  </div>

                  <!-- Customer Table -->
                  <div class="table-responsive">
                    <table class="table table-hover table-striped align-middle">
                      <thead class="table-light">
                      <tr>
                        <th>#</th>
                        <th>Phone Number</th>
                        <th>Customer Name</th>
                        <th>ID Number</th>
                        <th>Total Bills</th>
                        <th>Total Billed</th>
                        <th>Total Paid</th>
                        <th>Balance</th>
                        <th>Services</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(customer, index) in customers" :key="index">
                        <td>{{(currentPage - 1) * recordsPerPage + index + 1}}</td>
                        <td>{{maskPhoneNumber(customer.phoneNumber)}}</td>
                        <td class="text-capitalize">{{customer.customerName || '-'}}</td>
                        <td>{{customer.idNo || '-'}}</td>
                        <td>
                          <span class="badge bg-info">{{customer.totalBills || 0}}</span>
                        </td>
                        <td>{{formatPrice(customer.totalBilled || 0)}}</td>
                        <td>{{formatPrice(customer.totalPaid || 0)}}</td>
                        <td>
                                                        <span :class="customer.totalBalance > 0 ? 'text-danger fw-bold' : 'text-success'">
                                                            {{formatPrice(customer.totalBalance || 0)}}
                                                        </span>
                        </td>
                        <td>
                                                        <span v-if="customer.services" class="badge bg-secondary">
                                                            {{customer.services.split(',').length}} Services
                                                        </span>
                        </td>
                        <td>
                          <div class="btn-group btn-group-sm">
                            <button @click="viewProfile(customer)"
                                    class="btn btn-primary"
                                    title="View Profile">
                              <i class="bx bx-user"></i>
                            </button>
                            <button @click="viewStatement(customer)"
                                    class="btn btn-info"
                                    title="View Statement">
                              <i class="bx bx-file"></i>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Pagination -->
                  <div class="row mt-3" v-if="pagination.totalPages > 1">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{(currentPage - 1) * recordsPerPage + 1}} to
                        {{Math.min(currentPage * recordsPerPage, pagination.totalRecords)}}
                        of {{pagination.totalRecords}} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous"
                              :class="{disabled: !pagination.hasPrev}">
                            <a @click="changePage(currentPage - 1)"
                               class="page-link">Previous</a>
                          </li>
                          <li v-for="page in visiblePages"
                              :key="page"
                              class="paginate_button page-item"
                              :class="{active: page === currentPage}">
                            <a @click="changePage(page)" class="page-link">{{page}}</a>
                          </li>
                          <li class="paginate_button page-item next"
                              :class="{disabled: !pagination.hasNext}">
                            <a @click="changePage(currentPage + 1)"
                               class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Customer Profile Modal -->
      <div class="modal fade" id="profileModal" ref="profileModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Customer Profile</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div v-if="selectedProfile">
                <!-- Customer Info -->
                <div class="row mb-4">
                  <div class="col-12">
                    <div class="card">
                      <div class="card-body">
                        <h5 class="card-title mb-3">Customer Information</h5>
                        <div class="row">
                          <div class="col-md-3">
                            <p><strong>Phone:</strong> {{selectedProfile.customerInfo.phoneNumber}}</p>
                          </div>
                          <div class="col-md-3">
                            <p><strong>Name:</strong> {{selectedProfile.customerInfo.names}}</p>
                          </div>
                          <div class="col-md-3">
                            <p><strong>ID:</strong> {{selectedProfile.customerInfo.idNo}}</p>
                          </div>
                          <div class="col-md-3">
                            <p><strong>Email:</strong> {{selectedProfile.customerInfo.email || '-'}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Summary -->
                <div class="row mb-4">
                  <div class="col-md-3">
                    <div class="card">
                      <div class="card-body text-center">
                        <h6>Total Billed</h6>
                        <h4 class="text-primary">{{formatPrice(selectedProfile.summary.billing.totalBilled)}}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card">
                      <div class="card-body text-center">
                        <h6>Total Paid</h6>
                        <h4 class="text-success">{{formatPrice(selectedProfile.summary.billing.totalPaid)}}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card">
                      <div class="card-body text-center">
                        <h6>Balance</h6>
                        <h4 class="text-danger">{{formatPrice(selectedProfile.summary.billing.totalBalance)}}</h4>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="card">
                      <div class="card-body text-center">
                        <h6>Total Bills</h6>
                        <h4>{{selectedProfile.summary.billing.totalBills}}</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Tabs -->
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" data-bs-toggle="tab" href="#businesses">
                      Businesses ({{selectedProfile.businesses.length}})
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#properties">
                      Properties ({{selectedProfile.properties.landRates.length + selectedProfile.properties.plotRent.length}})
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#vehicles">
                      Vehicles ({{selectedProfile.vehicles.length}})
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#bills">
                      Bills ({{selectedProfile.bills.length}})
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" data-bs-toggle="tab" href="#permits">
                      Permits ({{selectedProfile.permits.length}})
                    </a>
                  </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content pt-3">
                  <!-- Businesses Tab -->
                  <div class="tab-pane active" id="businesses">
                    <div class="table-responsive">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th>Business ID</th>
                          <th>Name</th>
                          <th>Category</th>
                          <th>Location</th>
                          <th>Status</th>
                          <th>Balance</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="business in selectedProfile.businesses" :key="business.businessID">
                          <td>{{business.businessID}}</td>
                          <td>{{business.businessName}}</td>
                          <td>{{business.businessCategory}}</td>
                          <td>{{business.subCountyName}}, {{business.wardName}}</td>
                          <td>
                                                            <span class="badge"
                                                                  :class="business.permitStatus === 'ACTIVE' ? 'bg-success' : 'bg-danger'">
                                                                {{business.permitStatus || 'PENDING'}}
                                                            </span>
                          </td>
                          <td>{{formatPrice(business.billBalance || 0)}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Properties Tab -->
                  <div class="tab-pane" id="properties">
                    <h6>Land Rates Properties</h6>
                    <div class="table-responsive mb-3">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th>LR Number</th>
                          <th>Size</th>
                          <th>Address</th>
                          <th>Annual Charges</th>
                          <th>Arrears</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="property in selectedProfile.properties.landRates" :key="property.LRNumber">
                          <td>{{property.LRNumber}}</td>
                          <td>{{property.percelSize}}</td>
                          <td>{{property.percelAddress}}</td>
                          <td>{{formatPrice(property.annualCharges)}}</td>
                          <td>{{formatPrice(property.outstandingArrears)}}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Other tabs... -->
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeModal()">Close</button>
              <button @click="printProfile()" class="btn btn-primary">
                <i class="bx bx-printer"></i> Print Profile
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">©County Revenue System</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">Customer Management Module</div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </body>
  </div>
</template>

<script>
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {biller, execute} from "@/api";

export default {
  name: "CustomerManagement",
  components: {NavigationBar},

  data() {
    return {
      // Alert system
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: "",

      // Search and filters
      searchTerm: "",
      searchType: "all",
      filter: "all",
      sortBy: "recent",

      // Pagination
      currentPage: 1,
      recordsPerPage: 50,
      pagination: {
        currentPage: 1,
        totalPages: 1,
        totalRecords: 0,
        hasNext: false,
        hasPrev: false
      },

      // Data
      customers: [],
      statistics: {
        totalCustomers: 0,
        customersWithBalance: 0,
        activeCustomers: 0,
        totalRevenueBilled: 0,
        totalRevenueCollected: 0,
        totalOutstandingBalance: 0
      },
      selectedProfile: null,
      showProfileModal: false,

      // Loading states
      isLoading: false,
      isLoadingProfile: false,
      isExporting: false
    }
  },

  computed: {
    visiblePages() {
      const pages = [];
      const total = this.pagination.totalPages;
      const current = this.currentPage;

      let start = Math.max(1, current - 2);
      let end = Math.min(total, current + 2);

      if (current <= 3) {
        end = Math.min(5, total);
      }
      if (current >= total - 2) {
        start = Math.max(1, total - 4);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    }
  },

  mounted() {
    // Load the full customer list with details
    this.getAllCustomers();
    // Load statistics after a delay
    setTimeout(() => {
      this.getCustomerStatistics();
    }, 1000);
    this.menuAccess();
  },

  methods: {
    showAlert(type, message) {
      this.clearAlert();
      this.message = message;
      this.alert[type] = true;

      // Auto-hide after 5 seconds
      setTimeout(() => {
        this.clearAlert();
      }, 5000);
    },

    clearAlert() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
      this.message = "";
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Customers");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller)
          .then(() => {
            // Menu access logged
          })
          .catch(() => {
            // Handle error silently
          });
    },

    getQuickCustomerList() {
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getQuickCustomerList");
      data.append("page", this.currentPage);
      data.append("limit", this.recordsPerPage);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.customers = res.data.data.customers;
              this.pagination = res.data.data.pagination;

              // Don't load details automatically - let user click to see details
              // this.loadCustomerDetails();
            } else {
              this.showAlert('failed', res.data.message);
            }
          })
          .catch((e) => {
            this.showAlert('failed', e.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    getAllCustomers() {
      // Use the full query with all details
      this.isLoading = true;
      const data = new FormData();
      data.append("function", "getAllCustomers");
      data.append("page", this.currentPage);
      data.append("limit", this.recordsPerPage);
      data.append("filter", this.filter);
      data.append("sortBy", this.sortBy);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.customers = res.data.data.customers;
              this.pagination = res.data.data.pagination;
            } else {
              this.showAlert('failed', res.data.message);
            }
          })
          .catch((e) => {
            this.showAlert('failed', e.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    searchCustomers() {
      if (!this.searchTerm) {
        this.getAllCustomers();
        return;
      }

      this.isLoading = true;
      const data = new FormData();
      data.append("function", "searchCustomers");
      data.append("searchTerm", this.searchTerm);
      data.append("searchType", this.searchType);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.customers = res.data.data.customers;
              this.pagination = {
                currentPage: 1,
                totalPages: 1,
                totalRecords: res.data.data.customers.length,
                hasNext: false,
                hasPrev: false
              };
              if (res.data.data.customers.length === 0) {
                this.showAlert('info', 'No customers found matching your search criteria');
              }
            } else {
              this.showAlert('failed', res.data.message);
            }
          })
          .catch((e) => {
            this.showAlert('failed', e.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    getCustomerStatistics() {
      const data = new FormData();
      data.append("function", "getCustomerStatistics");

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.statistics = res.data.data.statistics;
            }
          })
          .catch(() => {
            // Handle error silently
          });
    },

    viewProfile(customer) {
      this.isLoadingProfile = true;
      const data = new FormData();
      data.append("function", "getCustomerProfile");
      data.append("phoneNumber", customer.phoneNumber);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.selectedProfile = res.data.data.profile;
              // Show modal using data attributes (Bootstrap 4 compatible)
              this.showProfileModal = true;
              this.$nextTick(() => {
                const modalElement = document.getElementById('profileModal');
                modalElement.classList.add('show');
                modalElement.style.display = 'block';
                document.body.classList.add('modal-open');

                // Add backdrop
                const backdrop = document.createElement('div');
                backdrop.className = 'modal-backdrop fade show';
                backdrop.id = 'modal-backdrop';
                document.body.appendChild(backdrop);
              });
            } else {
              this.showAlert('failed', res.data.message);
            }
          })
          .catch((e) => {
            this.showAlert('failed', e.message);
          })
          .finally(() => {
            this.isLoadingProfile = false;
          });
    },

    viewStatement(customer) {
      localStorage['customerStatement'] = JSON.stringify({
        phoneNumber: customer.phoneNumber,
        customerName: customer.customerName
      });
      const routeData = this.$router.resolve({name: 'customerStatement'});
      window.open(routeData.href, '_blank');
    },

    exportCustomers() {
      this.isExporting = true;
      const data = new FormData();
      data.append("function", "exportCustomers");
      data.append("format", "csv");
      data.append("filter", this.filter);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              // Download CSV
              const blob = new Blob([atob(res.data.data.data)], {type: res.data.data.mimeType});
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = res.data.data.filename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.showAlert('success', 'Export completed successfully');
            } else {
              this.showAlert('failed', res.data.message);
            }
          })
          .catch((e) => {
            this.showAlert('failed', e.message);
          })
          .finally(() => {
            this.isExporting = false;
          });
    },

    changePage(page) {
      if (page >= 1 && page <= this.pagination.totalPages) {
        this.currentPage = page;
        this.getAllCustomers();
      }
    },

    maskPhoneNumber(input) {
      if (!input || typeof input !== 'string') {
        return input;
      }

      const digits = input.replace(/\D/g, '');

      if (digits.length > 4) {
        return input.slice(0, 2) + input.slice(2, -2).replace(/\d/g, '*') + input.slice(-2);
      }

      return input;
    },

    formatPrice(value) {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 2
      });
      return formatter.format(value || 0);
    },

    formatNumber(value) {
      return new Intl.NumberFormat('en-US').format(value || 0);
    },

    gotTo(route) {
      router.push(route);
    },

    closeModal() {
      const modalElement = document.getElementById('profileModal');
      modalElement.classList.remove('show');
      modalElement.style.display = 'none';
      document.body.classList.remove('modal-open');

      // Remove backdrop
      const backdrop = document.getElementById('modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }

      this.showProfileModal = false;
    },

    printProfile() {
      if (this.selectedProfile) {
        localStorage['customerProfile'] = JSON.stringify(this.selectedProfile);
        const routeData = this.$router.resolve({name: 'customerProfilePrint'});
        window.open(routeData.href, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.search-box .search-icon {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #74788d;
}

.mini-stats-wid .mini-stat-icon {
  width: 60px;
  height: 60px;
}

.table td {
  vertical-align: middle;
}

.modal-xl {
  max-width: 90%;
}

.nav-tabs .nav-link {
  color: #495057;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.badge {
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.25rem 0.5rem;
}
</style>